import { cn } from '@/lib/utils';

import { TargetIcon } from '@/blocks/Scraper/TargetIcon';
import { Text } from '@/components/atoms/Text';

import { Target } from '../constants/targets';
import { useScraperTranslations } from '../scraperTranslations';

export const optionStyle = cn(
  'border-b dark:border-gray-dark-700 border-gray-300',
  'relative flex cursor-pointer items-center gap-3 hover:bg-gray-100',
  'py-2 lg:px-2 px-0'
);

const ScraperOption = ({
  target,
  handleSelect,
}: {
  target: Target;
  handleSelect: (value: string) => void;
}) => {
  const { getTranslation } = useScraperTranslations();
  return (
    <li
      className={optionStyle}
      data-tracker-context={target.targetKey}
      onClick={() => {
        if (target.unavailable) return;

        handleSelect(target.targetKey);
      }}
    >
      <TargetIcon target={target} />
      <Text classNames={{ wrapper: 'text-body-l' }}>
        {getTranslation(target.label) || ''}
      </Text>
    </li>
  );
};

export default ScraperOption;
